/*tslint:disable*/
/*eslint-disable*/
//This file was automatically generated and should not be edited.
import gql from 'graphql-tag';
export const Fragment_SeriesCard = gql`
  fragment Fragment_SeriesCard on Series {
    __typename
    id
    title
    localized_path
    entry_date {
      yyyymmdd
      timestamp
    }
    language
    cast
    thumbnail {
      processed_url
    }
    seasons {
      id
      episodes {
        id
      }
    }
  }
`;
